export var animations = {
    _320_3_ellipse_2: {
        y: [
            null,
            -10,
            0,
            0
        ],
        transition: {
            y: {
                repeat: Infinity,
                type: "keyframes",
                ease: [
                    [
                        0.42,
                        0,
                        1,
                        1
                    ],
                    [
                        0,
                        0,
                        0.58,
                        1
                    ]
                ],
                times: [
                    0,
                    0.5,
                    1,
                    1
                ],
                duration: 1.5
            }
        }
    },
    _320_4_ellipse_3: {
        y: [
            null,
            0,
            -10,
            0,
            0
        ],
        transition: {
            y: {
                repeat: Infinity,
                type: "keyframes",
                ease: [
                    [
                        0,
                        0,
                        1,
                        1
                    ],
                    [
                        0.42,
                        0,
                        1,
                        1
                    ],
                    [
                        0,
                        0,
                        0.58,
                        1
                    ]
                ],
                times: [
                    0,
                    0.166666667,
                    0.5,
                    0.8333,
                    1
                ],
                duration: 1.5
            }
        }
    },
    _320_6_ellipse_4: {
        y: [
            null,
            0,
            -10,
            0
        ],
        transition: {
            y: {
                repeat: Infinity,
                type: "keyframes",
                ease: [
                    [
                        0,
                        0,
                        1,
                        1
                    ],
                    [
                        0.42,
                        0,
                        1,
                        1
                    ],
                    [
                        0,
                        0,
                        0.58,
                        1
                    ]
                ],
                times: [
                    0,
                    0.3333333333333333,
                    0.6666666666666666,
                    1
                ],
                duration: 1.5
            }
        }
    }
};

//# sourceMappingURL=animations.js.map